import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class ReforestactionService {
  constructor(private http: HttpClient) { }

  getEvent(id: number): Observable<any> {
    return this.http
      .get(`${environment.api.event.get}${id}/leaderboard`)
      .pipe(map((res) => res));
  }

  getEventDetails(id: number): Observable<any> {
    return this.http
      .get(`${environment.api.event.get}infos/${id}`)
      .pipe(map((res) => res));
  }

  subscribeToEvent(id: number): Observable<any> {
    return this.http
      .post(`${environment.api.event.get}${id}/subscribe`, '')
      .pipe(map((res) => res));
  }
}
